export const paidServicesMap: Record<string, string> = {
  'Gerenciar Documentos': 'gerenciar_documentos',
  'Monitorar Chat': 'monitorar_chat',
  'Assinatura Digital': 'assinatura_digital',
  'Robô de Lance Inteligente': 'robo',
  'ConLicita Go': 'conlicitago',
  'Dr. Licita': 'dr_licita',
};
